<mat-list>
  <ng-container *ngFor="let source of knowledgeSources">
    <mat-list-item lines="3" class="knowledge-source-list">
      <mat-icon svgIcon="ai-knowledge-icon" class="knowledge-icon" matListItemIcon></mat-icon>
      <!-- Note: matListItemLine doesn't apply properly if these lines are in a container, so each line has a condition...-->

      <div matListItemTitle class="knowledge-source-title">
        <a class="knowledge-source-title-link" (click)="clickTitle(source)">{{ source.name }}</a>
        @if (source.isSuggested) {
          <glxy-badge [size]="'small'">Suggested</glxy-badge>
        }
      </div>

      <!-- Website Config Lines-->
      <div class="preview" *ngIf="source?.config?.websiteScrapeConfig" matListItemLine>
        <span>{{ getKnowledgePreview(source) }}</span>
      </div>
      <ai-knowledge-last-scraped
        [knowledgeSource]="source"
        [allowRescrapeWebsite]="this.allowRescrapeWebsite"
        (rescrapeInitiated)="rescrapeInitiated($event)"
      ></ai-knowledge-last-scraped>

      <!-- Non-Website Config Lines-->
      <span class="preview" *ngIf="!source?.config?.websiteScrapeConfig">{{ getKnowledgePreview(source) }}</span>

      <div matListItemMeta *ngIf="canRemoveSource(source)">
        <div>
          <mat-icon class="clickable" (click)="clickRemove(source)">close</mat-icon>
        </div>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-list>
